module.exports = __webpack_public_path__ + "static/media/ic_退出.1e469cb2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ic_退出.svg
// module id = 199
// module chunks = 0